"use strict";
var Observable_1 = require('../../Observable');
var timeout_1 = require('../../operator/timeout');
Observable_1.Observable.prototype.timeout = timeout_1.timeout;
//# sourceMappingURL=timeout.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/timeout.js
 ** module id = 316
 ** module chunks = 2
 **/